import {
  Box,
  Card,
  Checkbox,
  Dialog,
  FormControl,
  InputLabel,
  MenuItem,
  Button as MUIButton,
  Select,
  Tooltip,
  Typography,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { ReactElement, useState } from 'react';
import {
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  EditButton,
  Filter,
  FunctionField,
  List,
  TextField,
  NumberField,
  TopToolbar,
  useListController,
  useTranslate,
  DeleteButton,
  SelectField,
  TextInput,
  SelectInput,
} from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { Resources } from '../../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionButton } from 'src/routes/components/permission-button';
import SummaryCards from './SummaryCard';


const View = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const translate = useTranslate();

  return (
    <DashboardContent>
      <PermissionGuard resource="swap-dashboard" action="read" fallback={<ErrorPage403 />}>
        <CustomBreadcrumbs
          heading={translate('resource.transactionDashboard')}
          links={[
            { name: translate('resource.transaction'), href: '#' },
            {
              name: translate('resource.transactionDashboard'),
              href: `/${Resources.transactionDashboard}`,
            },
            { name: translate('resource.data') },
          ]}
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List
            actions={false}
            empty={false}
            // filters={<ListFilter />}
            perPage={10}
            exporter={false}
          >
            <SummaryCards />
            <Box sx={{ overflow: 'auto' }}>
              <Datagrid
                rowClick={false}
                sx={{
                  '.RaBulkActionsToolbar-toolbar': {
                    position: 'relative !important',
                    transform: 'none !important',
                  },
                }}
              >
                <TextField
                  source="type"
                  label="module.transactionDashboard.type"
                  sortable={false}
                />
                <TextField
                  source="chain"
                  label="module.transactionDashboard.chain"
                  sortable={false}
                />
                <TextField
                  source="token"
                  label="module.transactionDashboard.token"
                  sortable={false}
                />
                <NumberField
                  source="feeUsd"
                  label="module.transactionDashboard.feeUsd"
                  sortable={false}
                />
              </Datagrid>
            </Box>
          </List>
        </Card>
        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
      </PermissionGuard>
    </DashboardContent>
  );
};

export default View;
